import React, { useEffect, useState } from 'react';
import { Backdrop, Box, Modal, Fade, Typography, TextField, Button } from '@mui/material';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getprojectSettings, projectSettings } from '../../../../apis/projects.org';

function ProjectSettingsPage({
    selectedProj,
    access_token,
    token_type,
    openSettingsModal,
    setOpenSettingsModal,
    setIsToastOpen,
    setToastMessage,
    setLoading,
    setErrorCode
}) {
    const [formValues, setFormValues] = useState({
        workspace_name: '',
        api_key: '',
    });
    const [settingsData, setSettingsData] = useState(null);
    
    // Fetch project settings using getprojectSettings
    const { isLoading: loadingSettings } = useQuery({
        queryKey : ['projectSettings', selectedProj],
        queryFn : () => getprojectSettings({ selectedProj, payload: {}, access_token, token_type }),
        enabled: openSettingsModal && !!selectedProj,
        onSuccess: (data) => {
            setSettingsData(data)
        },
        onError: (error) => {
            console.error("Error fetching project settings:", error);
            setSettingsData(null);
        },
    });

    useEffect(() => {
        if (settingsData?.langsmith) {
            setFormValues({
                workspace_name: settingsData.langsmith.workspace_name || '',
                api_key: settingsData.langsmith.api_key || '',
            });
        } else if (settingsData) {
            setFormValues({
                workspace_name: '',
                api_key: '',
            });
        }
    }, [settingsData]);

    const mutation = useMutation({
        mutationFn : projectSettings,
        onSuccess: (res) => {
            setToastMessage('Workspace has been updated successfully');
            setLoading(false);
            setIsToastOpen(true);
            setOpenSettingsModal(false);
        },
        onError: (error) => {
            console.error("Error updating project settings:", error.response?.data);
            const errorMessage = error.response?.data?.detail || error.message || 'Unknown error';
            setToastMessage(`Error: ${errorMessage}`);
            setErrorCode(error?.response?.status);
            setLoading(false);
            setIsToastOpen(true);
        },
    });

    const ProjectSettingsFormSubmit = (e) => {
        e.preventDefault();
        const payload = {
            langsmith: {
                api_key: formValues?.api_key,
                workspace_name: formValues?.workspace_name,
            },
        };

        if (!payload?.langsmith.workspace_name || !payload?.langsmith.api_key) {
            setToastMessage("Workspace Name and API Key are required.");
            setIsToastOpen(true);
            return;
        }

        setLoading(true);
        mutation.mutate({ selectedProj, payload, access_token, token_type });
    };

    return (
        <>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={openSettingsModal}
                onClose={() => setOpenSettingsModal(false)}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
                className="createOrganizationModal"
                style={{ marginLeft: '100px', }}
            >
                <Fade in={openSettingsModal}>
                    <Box className="createOrganizationModalClass">
                        <div className="createOrganizationModalHeader">
                            <Typography
                                id="transition-modal-title"
                                variant="h6"
                                component="h2"
                                className="createOrganizationModalTitle"
                            >
                                Project Settings
                            </Typography>
                            <span
                                className="createOrganizationModalClose"
                                onClick={() => setOpenSettingsModal(false)}
                            >
                                &times;
                            </span>
                        </div>
                        <form className="g-3" onSubmit={ProjectSettingsFormSubmit}>
                            <div className="createOrganizationModalBody">
                                <div className="superAdminTitle">Langsmith</div>
                                <div className="d-flex" style={{ margin: '16px 0', position: 'relative' }}>
                                    <div className="col-12" style={{ paddingRight: '12px' }}>
                                        <label htmlFor="workspace_name" className="form-label">
                                            Workspace Name<span style={{ color: 'red' }}>&#65290;</span>
                                        </label>
                                        <TextField
                                            required
                                            id="workspace_name"
                                            placeholder="Workspace name"
                                            sx={{ width: '100%' }}
                                            onChange={(e) =>
                                                setFormValues({ ...formValues, workspace_name: e.target.value })
                                            }
                                            value={formValues?.workspace_name}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex" style={{ margin: '16px 0', position: 'relative' }}>
                                    <div className="col-12" style={{ paddingRight: '12px' }}>
                                        <label htmlFor="api_key" className="form-label">
                                            API Key<span style={{ color: 'red' }}>&#65290;</span>
                                        </label>
                                        <TextField
                                            required
                                            id="api_key"
                                            placeholder="API Key"
                                            sx={{ width: '100%' }}
                                            onChange={(e) =>
                                                setFormValues({ ...formValues, api_key: e.target.value })
                                            }
                                            value={formValues.api_key}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="createOrganizationFormButtons">
                                <Button
                                    variant="outlined"
                                    size="large"
                                    onClick={() => setOpenSettingsModal(false)}
                                >
                                    Cancel
                                </Button>
                                <Button variant="contained" size="large" type="submit" disabled={loadingSettings}>
                                    Submit
                                </Button>
                            </div>
                        </form>
                    </Box>
                </Fade>
            </Modal>
        </>
    );
}

export default ProjectSettingsPage;